export const TOP_BANNER_HEIGHT = 48;
